<template>
  <div :key="$route.path">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-sm-flex align-items-center justify-content-between">
          <div class="page-title-right">
            <h4 class="mb-sm-0 font-size-18">
              All Subcategories of Hypnosis
            </h4>
            <a @click="$router.go(-1)" class="btn btn-primary w-md mybutton myleft">
              <box-icon name="chevrons-left" type="solid" color="#ffffff" class="myicon"></box-icon>Back
            </a>
          </div>

          <div class="page-title-right">
            <!-- <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <router-link to="/home/all_libraries" class="waves-effect">
                    All Libraries List
                  </router-link>
                </li>
                <li class="breadcrumb-item active">All Audios' List</li>
              </ol> -->
            <div>
              <button class="btn btn-primary waves-effect btn-label waves-light mybutton" @click="showModal()">
                Add Subcategory
              </button>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <div class="col-lg-12">
        <div class="">
          <div class="table-responsive">
            <div class="card">
              <div class="card-body">
                <table class="table table-hover table-bordered" id="audios_table">
                  <thead>
                    <tr class="frown">
                      <th scope="col" style="width: 5%">#</th>
                      <th scope="col" style="width: 10%">Image</th>
                      <th scope="col" style="width: 20%">Title</th>
                      <!-- <th scope="col" style="width: 50%">Description</th> -->
                      <th scope="col" style="width: 50%">Timestamp</th>
                      <th scope="col" style="width: 50%">Status</th>
                      <th scope="col" style="width: 5%">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in all_audios" :key="index">
                      <td scope="row" class="sorting_1">{{ index + 1 }}</td>
                      <td>
                        <img :src="item.image" alt="" />
                      </td>
                      <td>
                        <h5>
                          {{ item.name }}
                        </h5>
                      </td>

                      <!-- <td>
                          <p>
                            {{ item.description }}
                          </p>
                        </td> -->

                      <td>
                        <p>
                          {{ item.created_at | moment("dddd, MMMM Do YYYY, h:mm:ss a") }}
                        </p>
                      </td>

                      <td>
                        <toggle-button @change="changeStatus(item)" :value="(item.status == 'Active') ? true : false" />
                      </td>

                      <td>
                        <!-- <div class="w3-dropdown-click mydropdown"> -->
                        <div class="dropdown">
                          <a href="javascript:;" class="dropdown-toggle card-drop" data-bs-toggle="dropdown" aria-expanded="false">
                            <box-icon name="dots-horizontal-rounded" class="myddicon"></box-icon>
                          </a>
                          <div class="dropdown-menu dropdown-menu-end dropdown-content w3-animate-zoom" id="myDIV">

                            <div>
                              <a @click="navigate(item.id, item.name)" class="listbox w3-bar-item w3-button">
                                <box-icon name="edit" class="myicon"></box-icon>
                                All Audios
                              </a>
                              <a href="javascript:;" @click="
                                showModal03(
                                  item.id,
                                  item.name,
                                  item.image,
                                )
                              " class="listbox w3-bar-item w3-button">
                                <box-icon name="edit" class="myicon"></box-icon>
                                Update Subcategory
                              </a>
                              <a href="javascript:;" @click="remove_aud(item.id)" class="listbox w3-bar-item w3-button">
                                <box-icon type="solid" name="message-alt-x" class="myicon"></box-icon>Delete Now
                              </a>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import ModalEditAudioCategoryHypnosis from "../Modals/ModalEditAudioCategoryHypnosis.vue";
import ModalAddAudioCategoryHypnosis from "../Modals/ModalAddAudioCategoryHypnosis.vue";
import api from "../../config/api.js";
import $ from "jquery";
export default {
  name: "AllAudios",
  data() {
    return {
      is_active: true,
      all_audios: [],
      hypnosis_cat_id: "",
      catname: "",

    };
  },

  created() {

    this.$root.$refs.Hypnosis = this;
    this.hypnosis_cat_id = this.$route.params.id;

    this.$watch(
      () => this.$route.params,
      () => {
        this.hypnosis_cat_id = this.$route.params.id;
        //this.$router.go();
        this.allSeries();
        //this.sayname(name)
        // console.log(this.$route.params)
      },
      // fetch the data when the view is created and the data is
      // already being observed
      { immediate: true }
    );
  },
  mounted() {
  
    //this.allaudios();
    this.hypnosis_cat_id = this.$route.params.id;
    this.allSeries();
  },

  methods: {

    async changeStatus(item){
      item.status = !item.status
      try {
        let result = await api.post(`/admin/hypno-cat-status?id=${item.id}`);
        this.$toast.success(result.data.message);
      } catch (error) {
        this.error = error.response.data.message;
        this.$toast.error(this.error);
      }
    },

    navigate_course(id, title) {
      this.$router.push({
        name: "videos",
        params: { id: id, title },
      });
    },

    async allSeries() {
      try {
        let result = await api.get('/admin/all-hypno-cat');
        setTimeout(() => {
          $("#audios_table").DataTable();
        }, 0);
        this.all_audios = result.data.categories;
      } catch (error) {
        this.error = error.response.data.message;
        this.$toast.error(this.error);
      }
    },

    async remove_aud(id) {
      try {
        this.$swal({
          title: "Are you sure to delete this Subcategory and all its tracks ?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No, cancel!",
          confirmButtonClass: "btn btn-success",
          cancelButtonClass: "btn btn-danger",
          buttonsStyling: true,
        }).then(async (res) => {
          if (res.isConfirmed) {
            let result = await api.delete('/admin/delete-hypnosis-cat/' + id);
            this.allSeries();
            this.$toast.success(result.data.message);
            // console.log("I am in Delete mode", result);
            //this.onLoad();
          }
        });
      } catch (error) {
        this.$toast.error(error.response.data.message);
      }
    },

    navigate(id, title) {
      this.$router.push({
        name: "hypnosis",
        params: { id: id, title },
      });
      this.$root.$refs.Hypnosis.sayname(title);
    },


    showModal() {
      console.log(this.add_api);
      this.$modal.show(
        ModalAddAudioCategoryHypnosis,
        {
          add_api: this.add_api
        },
        { draggable: true },
        {
          "before-close": () => {
            this.onLoad();
          },
        }
      );
    },

    showModal03(id, name, image) {
      this.$modal.show(
        ModalEditAudioCategoryHypnosis,
        { id, name, image },
        { draggable: true },
        {
          "before-close": () => {
            //this.allAudios(libid);
          },
        }
      );
    },

    onload() {
      this.allSeries();
    },
    callme() {
      this.allSeries();
    },
    sayname(name) {
      this.catname = name;
    },
  },
};
</script>
  
<style scoped>
.dropdown-menu{
  width: 200px;
}

#audios_table h5 {
  /* line-height: 65px; */
  margin-top: 15px;
}

#audios_table .switch {
  margin-top: 25px;
}

#audios_table .dropdown {
  margin-top: 15px;
}
</style>
  